import * as Yup from 'yup';

// Search Users validation schema
export const SearchUsersSchema = Yup.object().shape({
  email: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters'),
  firstName: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters'),
  lastName: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters'),
  phone: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters')
});
